import { CONSTANTS } from '@/constants';
import { useUserContext } from '@/contexts/UserContext';
import { getValidClassNames } from '@/utils';
import { Button } from '@netfront/ui-library';
import Link from 'next/link';
import { Header } from '@/components/Header/Header';
import React from 'react';
import SmallScreenNavigationSideMenu from '@/components/SmallScreenNavigationSideMenu/SmallScreenNavigationSideMenu';
import { UserMenu } from '@/components/UserMenu/UserMenu';

export type PublicHeaderVariant = 'public' | 'console';

export type PublicHeaderProps = {
  variant?: PublicHeaderVariant;
};

export const PublicHeader = ({ variant = 'public' }: PublicHeaderProps) => {
  const { user } = useUserContext();
  const isConsole = variant === 'console';

  function renderRightHandSideChildren() {
    if (user) {
      if (isConsole) {
        return (
          <>
            <div className="flex items-center">
              <UserMenu />
            </div>
            <div className="flex xl:none c-mobile-menu-button">
              <SmallScreenNavigationSideMenu triggerIconClass="text-primary-foreground" />
            </div>
          </>
        );
      }

      return <Button additionalClassNames="ml-4" linkButton={{ id: 'return', url: '/console' }} text="Go to dashboard" variant="accent" />;
    }

    return (
      <>
        <div aria-label="Login and registration" className="ml-auto none xl:flex">
          <Button additionalClassNames="mr-4" linkButton={{ id: 'register', url: '/register' }} text="Register" variant="accent" />
          <Button linkButton={{ id: 'login', url: '/login' }} text="Login" variant="secondary" />
        </div>
        <div className="flex xl:none">
          <Button linkButton={{ id: 'register', url: '/register' }} text="Register" variant="accent" />
        </div>
        <div className="flex xl:none c-mobile-menu-button">
          <SmallScreenNavigationSideMenu triggerIconClass="text-primary-foreground" />
        </div>
      </>
    );
  }

  const menuItems = (isConsole && !!user) ? CONSTANTS.MENU.PRIVATE : CONSTANTS.MENU.PUBLIC;
  const logoHref = (isConsole && !!user) ? '/exercise' : '/';

  return (
    <Header
      logo={{ href: logoHref }}
      middleChildren={
        <ul className="flex list-style-none none xl:flex flex-1 justify-center absolute left-1/2 -translate-x-50">
          {menuItems.map(({ href, id, label }) => (
            <li key={`public-header-${id}`} className="m-0">
              <Link
                className={getValidClassNames({
                  'flex color-white weight-500 px-8 py-12 text-decoration-none': true,
                })}
                href={String(href)}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      }
      rightHandSideChildren={renderRightHandSideChildren()}
    />
  );
};
